module.exports = __webpack_public_path__ + "img/GF.374f8e19.png";